import axios from "axios";
import { auth } from "./firebase";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use(async (config) => {
  const user = auth.currentUser;
  if (user) {
    try {
      const token = await user.getIdToken();
      config.headers.Authorization = `Bearer ${token}`;
    } catch (_) {}
  }
  return config;
});

/**
 * Normalize any axios/Pydantic error into a string we can safely render.
 * FastAPI's 422 returns `detail` as an array of {type, loc, msg, ...} objects —
 * passing those raw to a toast or React renders an error.
 */
export function errMsg(err, fallback = "Something went wrong") {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) {
    return d
      .map((e) => (typeof e === "string" ? e : e?.msg || JSON.stringify(e)))
      .join(", ");
  }
  return JSON.stringify(d);
}

export default api;
